import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Logo } from "../ds";

import CampoSenha from "../components/CampoSenha";
import { ApiError } from "../api/client";
import { useAuth } from "../auth/AuthContext";

interface TenantOpcao {
  slug: string;
  name: string;
}

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [tenantSlug, setTenantSlug] = useState("");
  const [opcoes, setOpcoes] = useState<TenantOpcao[]>([]);
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const destino = (location.state as { from?: string } | null)?.from;

  async function enviar(evento: React.FormEvent) {
    evento.preventDefault();
    setEnviando(true);
    setErro(null);

    try {
      const usuario = await login(email, senha, tenantSlug || undefined);

      if (usuario.must_change_password) {
        navigate("/trocar-senha", { replace: true });
        return;
      }
      // Direto ao painel do papel, sem escalar pela raiz: `/` só reencaminharia,
      // e o salto extra pisca uma tela vazia no meio do caminho.
      navigate(destino ?? (usuario.role === "SUPERADMIN" ? "/superadmin" : "/painel"), {
        replace: true,
      });
    } catch (falha) {
      if (falha instanceof ApiError && falha.code === "TENANT_REQUIRED") {
        // O mesmo e-mail existe em mais de uma empresa: só agora, com a senha
        // já conferida, é seguro perguntar de qual delas se trata.
        const lista = (falha.payload as { tenants?: TenantOpcao[] } | null)?.tenants ?? [];
        setOpcoes(lista);
        setErro("Este e-mail está cadastrado em mais de uma empresa. Escolha qual delas.");
      } else if (falha instanceof ApiError) {
        setErro(falha.message);
      } else {
        setErro("Não foi possível conectar. Verifique sua conexão e tente de novo.");
      }
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="shell">
      <div className="brand">
        <Logo tamanho={32} titulo="Passaporte Digital de Válvula" />
        <b>Aletia</b>
        <span>Armaturen · Valve Passport</span>
      </div>

      <form className="card card-estreito" onSubmit={enviar}>
        <h1>Entrar na plataforma</h1>
        <p className="sub">Use as credenciais fornecidas pelo administrador da sua empresa.</p>

        <label className="campo">
          <span>E-mail</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
            autoFocus
          />
        </label>

        <CampoSenha rotulo="Senha" valor={senha} onChange={setSenha} />

        {opcoes.length > 0 && (
          <label className="campo">
            <span>Empresa</span>
            <select value={tenantSlug} onChange={(e) => setTenantSlug(e.target.value)} required>
              <option value="">Selecione…</option>
              {opcoes.map((opcao) => (
                <option key={opcao.slug} value={opcao.slug}>
                  {opcao.name}
                </option>
              ))}
            </select>
          </label>
        )}

        {erro && (
          <p className="alerta" role="alert">
            {erro}
          </p>
        )}

        <button type="submit" className="btn btn-primario" disabled={enviando}>
          {enviando ? "Entrando…" : "Entrar"}
        </button>

        <p className="muted login-rodape">
          <Link to="/esqueci-senha">Esqueci minha senha</Link>
        </p>
      </form>
    </div>
  );
}
